import { template } from "@libs/layouts"
import { Widgets } from "@libs/utilities"

const LayoutRight = () : JSX.Element | null => {
    return template().right
        ?
        <div className="p-0">
            <Widgets areaName="layout-right" data={{ }} />
        </div>
        : 
        null
} 

export default LayoutRight